// format and parse date-string if possible
export function parseDateString(dateString) {
  let formats = [
    {
      valid: /^\d{4}(?:-\d\d){2}T(?:\d\d:){2}\d\d(?:\.\d{3}Z?|\+\d\d:\d\d)?$/,
      find: /(.+)/,
      sub: '$1'
    },
    {
      valid: /^\d{4}(?:-\d\d){2}T(?:\d\d:){2}\d\d\+\d{4}$/,
      find: /^(\d{4}(?:-\d\d){2}T(?:\d\d:){2}\d\d\+\d\d)(\d\d)$/,
      sub: '$1:$2'
    },
    {
      valid: /^\d{4}(?:-\d\d){2}T(?:\d\d:){2}\d\d.+$/,
      find: /(^\d{4}(?:-\d\d){2}T(?:\d\d:){2}\d\d).+$/,
      sub: '$1'
    }
  ]

  let validDate = formats.some(format => {
    let valid = format.valid.test(dateString)

    if (valid) {
      dateString = dateString.replace(format.find, format.sub)
    }

    return valid
  })

  return (!validDate) ? new Date()
  : new Date(dateString)
}



// WEBPACK FOOTER //
// ./src/api/utils/helpers.js